import http from '../http_v2'
let list = (data) => {
    return http.post('opservice/group/page', data)
}
let list1 = (data) => {
  return http.post('opservice/group/without/count/page', data)
}
let gudingList = (data) => {
  return http.get('opservice/group/list', data)
}
export default {
    list,
    list1,
    gudingList,//固定组
    get: 'opservice/group/get', //根据ID查询用户
    save: 'opservice/group/upsert', //保存或更新用户分组信息
    del: 'opservice/group/delete', //删除用户分组(支持批量）
    grouplist: 'opservice/group/page', //分页查询用户组
    type: 'opservice/group/list', //根据类型获取用户组(固定组)
    userlist: 'opservice/group/listuser', //根据ID查询用户
}
